(function () {
  'use strict';

  const MQ = '(max-width: 749px)';
  let ticking = false;

  function getHeader() {
    return document.querySelector('.page-header header-component[data-header-sticky]');
  }

  function update() {
    ticking = false;
    if (!window.matchMedia(MQ).matches) return;

    const header = getHeader();
    if (!header) return;

    /* Transparent header on mobile: always stuck (solid bar, dark logo/icons). */
    if (header.hasAttribute('data-header-transparent')) {
      header.classList.add('js__header__stuck');
      return;
    }

    const y = window.scrollY || document.documentElement.scrollTop;
    const atTop = y <= 2;

    if (atTop) {
      if (!document.documentElement.hasAttribute('data-scroll-locked')) {
        header.classList.remove('js__header__stuck');
      }
    } else {
      header.classList.add('js__header__stuck');
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  function init() {
    document.addEventListener('theme:scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('theme:resize:width', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
